import { faCircleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { NotificationDispatch } from '@tryhackme/thm-ui-components';
import { useCallback } from 'react';
import { useAppDispatch } from 'src/app/hooks';
import { clearSplitScreenVmOrAllVms } from 'src/app/reducers/split-screen.reducer';
import { StandardActionModal } from 'src/common/components/standard-action-modal';
import { StyledModalIcon } from 'src/common/components/standard-action-modal/standard-action-modal.styles';
import { TaskType } from 'src/common/enums/task';
import { hasErrorPostData } from 'src/common/helpers/slices';
import { StyledModalBodyText } from 'src/features/room/components/commons';
import { useTerminateVmMutation } from 'src/features/room/room.slice';
import type { TerminateMachineModalProps } from 'src/features/room/room.types';
const iconComponent = <StyledModalIcon data-icon="error" icon={faCircleExclamation} />;
const modalBodyText = <StyledModalBodyText>Are you sure you want to terminate this machine?</StyledModalBodyText>;
export const TerminateMachineModal = ({
  open,
  onOpenChange,
  runningInstance,
  onComplete
}: TerminateMachineModalProps) => {
  const [terminateMachineTrigger] = useTerminateVmMutation();
  const dispatch = useAppDispatch();
  const handleTerminateMachine = useCallback(() => {
    // Immediately update UI state (optimistic update)
    dispatch(clearSplitScreenVmOrAllVms({
      type: TaskType.VM,
      vm: runningInstance
    }));
    NotificationDispatch('info', 'Your machine is being terminated...');

    // Close modal immediately
    onComplete?.();

    // Let termination complete in background
    terminateMachineTrigger(runningInstance.id).then(result => {
      if (hasErrorPostData(result)) {
        NotificationDispatch('error', result.error?.data?.message ?? 'Something went wrong while terminating the machine.');
        return;
      }
      NotificationDispatch('success', 'Your machine has been terminated successfully');
    }).catch(() => {
      NotificationDispatch('error', 'An unexpected error occurred while terminating the machine.');
    });
  }, [runningInstance, terminateMachineTrigger, dispatch, onComplete]);
  return <StandardActionModal modalTitleText="Terminate Machine" modalBodyText={modalBodyText} dismissButtonTitle="Cancel" actionButtonTitle="Terminate Machine" handleModalAction={handleTerminateMachine} showIcon iconComponent={iconComponent} open={open} onOpenChange={onOpenChange} data-sentry-element="StandardActionModal" data-sentry-component="TerminateMachineModal" data-sentry-source-file="terminate-machine-modal.tsx" />;
};